import _extends from '@babel/runtime/helpers/extends';
import { forwardRef, Icon } from '@chakra-ui/react';
import * as React from 'react';

var Svg = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 16"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 9.28l2.45 1.49-.65-2.81L8 6.08l-2.89-.25L4 3.19 2.87 5.83 0 6.08l2.18 1.88-.68 2.81L4 9.28z",
    fillRule: "evenodd"
  }));
});
var AccountStar = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    as: Svg
  }, props, {
    ref: ref
  }));
});

export { AccountStar };
//# sourceMappingURL=AccountStar.js.map
